import { render, staticRenderFns } from "./VouchersView.vue?vue&type=template&id=3b4fad58&"
import script from "./VouchersView.vue?vue&type=script&lang=js&"
export * from "./VouchersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports